import React from "react";

import { SelectStyled } from "../../assets/styles/components/select";

const Select = ({ children, onClickIcon = () => {}, ...rest }) => {
  return (
    <SelectStyled {...rest}>
      {children}
      {/* {icon && <SpanStyled onClick={onClickIcon}>{icon}</SpanStyled>} */}
    </SelectStyled>
  );
};

export default Select;
